import { render, staticRenderFns } from "./FleetItemPlaceholder.vue?vue&type=template&id=3b6dc8b6&scoped=true&"
import script from "./FleetItemPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FleetItemPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./FleetItemPlaceholder.vue?vue&type=style&index=0&id=3b6dc8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6dc8b6",
  null
  
)

export default component.exports